if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,
        version: '',
        init() {
          // Heron: snippets/cart-terms-label.liquid supplies the terms version for this
          // customer (wholesale or general) and whether this cart already agreed to it.
          // State comes from the cart itself, so every new cart (every new order) starts
          // unchecked, and the version agreed to is saved on the order.
          const label = this.$el.querySelector('[data-terms-version]');
          if (label) {
            this.version = label.dataset.termsVersion || '';
            this.checked = label.dataset.termsAgreed === 'true';
            localStorage.cart_term_checked = this.checked ? 'agreed' : 'not agreed';
          } else {
            this.checked = localStorage.cart_term_checked == 'agreed' ? true : false;
          }

          this.$watch('checked', () => {
            this.save();
          });

          document.addEventListener('eurus:cart:validate', () => {
            this.checked = localStorage.cart_term_checked == 'agreed' ? true : false;
            if (!this.checked) Alpine.store('xCartHelper').validated = false;
          });
        },
        save() {
          clearTimeout(this.t);

          // Set right away so checkout validation never reads a stale value.
          localStorage.cart_term_checked = this.checked ? 'agreed' : 'not agreed';

          const func = () => {
            var status;
            if (this.version) {
              status = this.checked ? 'Agreed: ' + this.version : 'Not agreed';
            } else {
              status = this.checked ? 'agreed' : 'not agreed';
            }
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Terms and conditions': status
              }
            });
          }

          this.t = setTimeout(() => {
            func();
          }, 200);
        }
      }));
    })
  });
};
